import { InfoOutlined as InfoOutlinedIcon } from 'components/icons';
import LazyTooltip from 'components/LazyTooltip';
import { useMemo } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'store';
import { EditIntentTypeCode, InvoiceRowCorrectionForm } from 'types/invoices';
import { t } from 'utils/getTranslations';

type Props = {
    index: number;
    invoiceRowId: number;
    editIntentTypeCode: string | null;
    setValue: UseFormSetValue<InvoiceRowCorrectionForm>;
    handleUpdateInvoiceRows: (idList: number[]) => void;
};

export const TakeActionBackDisplay = ({
    index,
    invoiceRowId,
    editIntentTypeCode,
    setValue,
    handleUpdateInvoiceRows,
}: Props) => {
    const { buttonsDisabled } = useSelector((state) => state.buttons);

    const invoiceRowChangedText = useMemo(() => {
        switch (editIntentTypeCode) {
            case EditIntentTypeCode.REMOVE_VIA_CORRECTION: {
                return t('invoices.details.table.row-is-credited');
            }
            default: {
                return '';
            }
        }
    }, [editIntentTypeCode]);

    const invoiceRowTooltipText = useMemo(() => {
        switch (editIntentTypeCode) {
            case EditIntentTypeCode.REMOVE_VIA_CORRECTION: {
                return t('invoices.details.table.row-is-credited-tooltip');
            }
            default: {
                return '';
            }
        }
    }, [editIntentTypeCode]);

    const handleToTakeActionBack = () => {
        setValue(`rows.${index}.editIntentTypeCode`, null, { shouldDirty: true });
        handleUpdateInvoiceRows([invoiceRowId]);
    };

    return (
        <div className="pointer-events-auto mb-2 opacity-100">
            <p className="text-body2 text-fg-error flex items-center">
                {invoiceRowChangedText}
                <LazyTooltip title={invoiceRowTooltipText} placement="bottom">
                    <InfoOutlinedIcon className="text-fg-secondary ml-[1px] h-[1.2rem]" />
                </LazyTooltip>
                <button
                    type="button"
                    onClick={handleToTakeActionBack}
                    disabled={buttonsDisabled}
                    className="text-fg hover:text-link cursor-pointer underline disabled:pointer-events-none disabled:opacity-50"
                >
                    <FormattedMessage id="invoices.actions.take-back" />
                </button>
            </p>
        </div>
    );
};
